import React, { useState, useContext } from "react";
import { Layout, Menu, Grid } from "antd";
import { RightOutlined, LogoutOutlined } from "@ant-design/icons";

import {
    useTranslate,
    useMenu,
    useLogout,
    useTitle,
    useNavigation,
} from "@hooks";
import { AuthContext } from "@contexts/auth";
import { CanAccess } from "@components";
import { IAuthContext } from "../../../../interfaces";
import { antLayoutSider, antLayoutSiderMobile } from "./styles";

export const Sider: React.FC = () => {
    const [collapsed, setCollapsed] = useState<boolean>(false);
    const { isProvided } = useContext<IAuthContext>(AuthContext);
    const { mutate: logout } = useLogout();
    const Title = useTitle();
    const translate = useTranslate();
    const { menuItems, selectedKey } = useMenu();
    const { push } = useNavigation();
    const breakpoint = Grid.useBreakpoint();

    const isMobile = !breakpoint.lg;

    return (
        <Layout.Sider
            collapsible
            collapsed={collapsed}
            onCollapse={(collapsed: boolean): void => setCollapsed(collapsed)}
            collapsedWidth={isMobile ? 0 : 80}
            breakpoint="lg"
            style={isMobile ? antLayoutSiderMobile : antLayoutSider}
        >
            <Title collapsed={collapsed} />
            <Menu
                selectedKeys={[selectedKey]}
                mode="inline"
                onClick={({ key }) => {
                    if (key === "logout") {
                        logout();
                        return;
                    }

                    if (!breakpoint.lg) {
                        setCollapsed(true);
                    }

                    push(key as string);
                }}
            >
                {menuItems.map(({ icon, label, route, name }) => {
                    const isSelected = route === selectedKey;
                    return (
                        <CanAccess
                            key={route}
                            resource={name.toLowerCase()}
                            action="list"
                        >
                            <Menu.Item
                                style={{
                                    fontWeight: isSelected ? "bold" : "normal",
                                }}
                                icon={icon}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    {label}
                                    {!collapsed && isSelected && (
                                        <RightOutlined />
                                    )}
                                </div>
                            </Menu.Item>
                        </CanAccess>
                    );
                })}

                {isProvided && (
                    <Menu.Item key="logout" icon={<LogoutOutlined />}>
                        {translate("buttons.logout", "Logout")}
                    </Menu.Item>
                )}
            </Menu>
        </Layout.Sider>
    );
};
